//User Registration Page for new users(clients companies)
import {useState,useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
import {toast} from 'react-toastify'
import {useSelector} from 'react-redux'
import {useDispatch} from 'react-redux'
import {register} from '../features/auth/authSlice'
import Spinner from '../components/Spinner'

function Register (){
    const [agreement, setAgreement] = useState(false)
    const [formData, setFormData] = useState({
        companyName:'',
        name:'',
        email:'',
        phone:'',
        password:'',
        password2:''
    }) 

    const {companyName, name, email, phone, password, password2} = formData

    const dispatch = useDispatch()
    const navigate = useNavigate()
    
    //get current values from global state redux
    const {user, isError, isSuccess, isLoading, message} = useSelector(state => state.auth)

     useEffect(()=>{
        if(isError){
            
            toast.error(message)
        }
        if(isSuccess || user){
             
            navigate('/verify')
            

        }

        //do no reset, instead send verification code
        // dispatch(reset())

    },[isError,isSuccess,user,message,navigate,dispatch])



    const onChange = (e) => {
        if (e.target.name === "name") {
            // Allow only letters and spaces
            const alphabeticValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
            setFormData((prevState) => ({
                ...prevState,
                [e.target.name]: alphabeticValue,
            }));
        } else if (e.target.name === "phone") {
          // remove all non-numeric characters from the input value
          const numericValue = e.target.value.replace(/\D/g, '');
          // limit the input to accept only 10 digits
          const limitedValue = numericValue.substring(0, 10);
          // add "-" after 3rd and 6th digits
          let formattedValue = '';
          for (let i = 0; i < limitedValue.length; i++) {
            if (i === 3 || i === 6) {
              formattedValue += '-';
            }
            formattedValue += limitedValue.charAt(i);
          }
          setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: formattedValue,
          }));
        } else {
          setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
          }));
        }
      };
      
    

    const onSubmit = (e) =>{
        e.preventDefault()
        if (!agreement) {
            toast.warning('You must agree to the privacy policy before submitting.');
            return;
        }

        if(password !== password2){
            toast.error("passowords do not match")
            return;
        }

        const userData = {
                name,
                email,
                phone,
                password,
                companyName,
        }
        dispatch(register(userData));    
    }

    if(isLoading) {
        return<Spinner/>
    }

    return(
        <>  
        <div className='min-h-screen bg-bg px-4 py-6 sm:px-6 lg:px-8'>
            <div className="mx-auto flex w-full max-w-6xl flex-col overflow-hidden rounded-2xl border border-border bg-surface shadow-sm md:flex-row">
                {/* Left Side */}
                <div className="w-full border-b border-border bg-ink p-8 md:w-2/5 md:border-b-0 md:border-r md:border-white/10">
                    <h1 className="text-4xl font-semibold tracking-tight text-white md:text-5xl">Get Started</h1>
                    <p className="mt-4 text-sm leading-7 text-white/70 md:text-base">
                        Register your business account and start managing jobsites, workers, and attendance from one place.
                    </p>
                    <div className="mt-8 rounded-xl border border-white/20 bg-white/10 p-4">
                        <p className="text-eyebrow uppercase text-white/50">What You Need</p>
                        <ul className="mt-3 space-y-2 text-sm text-white/80">
                            <li>Business contact details</li>
                            <li>Phone number for SMS verification</li>
                            <li>A secure password</li>
                        </ul>
                    </div>
                    <p className="mt-6 text-xs text-white/50">
                        Already have an account? <a href="/login" className="underline text-white/80">Sign in</a>
                    </p>
                </div>

                {/* Right Side */}
                <div className="w-full p-6 md:w-3/5 md:p-8">
                    <section>
                        <p className="mb-6 text-sm text-ink-2">
                            For businesses who want to get started, please fill out the form below.
                        </p>
                    </section>

                    <section>
                        <form onSubmit={onSubmit} className="space-y-5">

                            <div className='form-group mb-4 text-left'>
                                <label htmlFor="companyName" className="mb-2 block text-label text-ink">Business Name</label>
                                <input className='h-10 w-full rounded-md border border-border bg-surface px-3 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40'
                                    type='text' id='companyName' name='companyName' value={companyName} onChange={onChange} placeholder='DryWall Contracting' required>
                                </input>
                            </div>

                            <div className='form-group mb-4 text-left'>
                                <label htmlFor="name" className="mb-2 block text-label text-ink">Contact Name</label>
                                <input className='h-10 w-full rounded-md border border-border bg-surface px-3 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40'
                                    type='text' id='name' name='name' value={name} onChange={onChange} placeholder='Enter your name' required>
                                </input>
                            </div>

                            <div className='form-group mb-4 text-left'>
                                <label htmlFor="email" className="mb-2 block text-label text-ink">Business Email</label>
                                <input className='h-10 w-full rounded-md border border-border bg-surface px-3 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40'
                                    type='email' id='email' name='email' value={email} onChange={onChange} placeholder='person@business.com' required>
                                </input>
                            </div>

                            <div className='form-group mb-4 text-left'>
                                <label htmlFor="phone" className="mb-2 block text-label text-ink">Business Phone Number</label>
                                <p className='mb-2 text-eyebrow text-ink-3'>Must be able to receive text messages for verification.</p>
                                <input className='h-10 w-full rounded-md border border-border bg-surface px-3 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40'
                                    type='tel' id='phone' name='phone' value={phone} onChange={onChange} placeholder='123-123-1234' required>
                                </input>
                            </div>

                            <div className='form-group mb-4 text-left'>
                                <label htmlFor="password" className="mb-2 block text-label text-ink">Password</label>
                                <input className='h-10 w-full rounded-md border border-border bg-surface px-3 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40'
                                    type='password'
                                    id='password'
                                    name='password'
                                    value={password}
                                    onChange={onChange}
                                    placeholder='$ecurePa$$w0rd123' required>
                                </input>
                            </div>

                            <div className='form-group mb-6 text-left'>
                                <label htmlFor="password2" className="mb-2 block text-label text-ink">Confirm Password</label>
                                <input className='h-10 w-full rounded-md border border-border bg-surface px-3 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40'
                                    type='password'
                                    id='password2'
                                    name='password2'
                                    value={password2}
                                    onChange={onChange}
                                    placeholder='Confirm Password' required>
                                </input>
                            </div>

                            <div className='mb-4 text-left'>
                                <label className='inline-flex items-start text-body text-ink-2'>
                                    <input type='checkbox'
                                        className='mt-0.5 h-4 w-4 rounded border-border focus:ring-brand/40'
                                        onChange={(e) => setAgreement(e.target.checked)}
                                    />
                                    <span className='ml-2'>I agree to the <a href='/privacyPolicy' className='underline text-ink'>Privacy Policy</a> and to receive SMS verification code.</span>
                                </label>
                            </div>

                            <div className='flex justify-end'>
                                <button className='inline-flex h-10 items-center rounded-md bg-ink px-8 text-label font-medium text-white transition hover:bg-ink-2' type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </section>
                </div>
            </div>
        </div>
               
        </>
        
    )
  }


  export default Register
